// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1ZrxV","emoji":"classes_emoji__2G7yK","title":"classes_title__2iXd2","description":"classes_description__mxDSE","button":"classes_button__3cYRe"};